// utils/relief3d.js
// Idempotent: call it on every state change AND after every style.load.

const DEM_SOURCE = "mapbox-dem";
const STREETS_SOURCE = "mapbox-streets-3d"; // own source: works on any basemap (satellite too)
const SKY_LAYER = "sky-3d";
const BUILDINGS_LAYER = "buildings-3d";

const firstSymbolLayerId = (map) =>
  map.getStyle()?.layers?.find((l) => l.type === "symbol")?.id;

/* ------------------------------- terrain ------------------------------- */
export function setTerrain3D(map, on, exaggeration = 1.4) {
  if (on) {
    if (!map.getSource(DEM_SOURCE)) {
      map.addSource(DEM_SOURCE, {
        type: "raster-dem",
        url: "mapbox://mapbox.mapbox-terrain-dem-v1",
        tileSize: 512,
        maxzoom: 14,
      });
    }
    map.setTerrain({ source: DEM_SOURCE, exaggeration });

    if (!map.getLayer(SKY_LAYER)) {
      map.addLayer({
        id: SKY_LAYER,
        type: "sky",
        paint: {
          "sky-type": "atmosphere",
          "sky-atmosphere-sun": [0.0, 0.0],
          "sky-atmosphere-sun-intensity": 12,
        },
      });
    }
  } else {
    if (map.getTerrain()) map.setTerrain(null);
    if (map.getLayer(SKY_LAYER)) map.removeLayer(SKY_LAYER);
    if (map.getSource(DEM_SOURCE)) map.removeSource(DEM_SOURCE);
  }
}

/* --------------------------- 3D buildings ------------------------------ */
export function setBuildings3D(map, on) {
  if (on) {
    if (!map.getSource(STREETS_SOURCE)) {
      map.addSource(STREETS_SOURCE, {
        type: "vector",
        url: "mapbox://mapbox.mapbox-streets-v8",
      });
    }
    if (!map.getLayer(BUILDINGS_LAYER)) {
      map.addLayer(
        {
          id: BUILDINGS_LAYER,
          type: "fill-extrusion",
          source: STREETS_SOURCE,
          "source-layer": "building",
          minzoom: 14,
          filter: ["==", ["get", "extrude"], "true"],
          paint: {
            // height-based tint: low = light neutral, tall = brand purple
            "fill-extrusion-color": [
              "interpolate",
              ["linear"],
              ["coalesce", ["get", "height"], 0],
              0, "#E3DFFF",
              20, "#BDB8E0",
              60, "#8B86C4",
              120, "#5A55A0",
            ],
            "fill-extrusion-height": ["coalesce", ["get", "height"], 0],
            "fill-extrusion-base": ["coalesce", ["get", "min_height"], 0],
            "fill-extrusion-opacity": 0.88,
            "fill-extrusion-vertical-gradient": true,
          },
        },
        firstSymbolLayerId(map), // keep labels on top
      );
    }
  } else {
    if (map.getLayer(BUILDINGS_LAYER)) map.removeLayer(BUILDINGS_LAYER);
    if (map.getSource(STREETS_SOURCE)) map.removeSource(STREETS_SOURCE);
  }
}

export function syncRelief(map, { terrain, buildings3d }) {
  setTerrain3D(map, !!terrain);
  setBuildings3D(map, !!buildings3d);
}